import { ChecklistItemStatus } from './../types/checklist_types';
import { ChecklistItem } from './../builders/checklist_item_builder';
import { IChecklistItemsDatasource } from './../datasources/checklist_items_datasource';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';

angular
  .module('capability-ng-checklist')
  .factory('udpateChecklistItemStatusLocalCommand', (defineCommand: IDefineCommand, QueryMediator: IQueryMediator, ngChecklistItemsDatasource: IChecklistItemsDatasource): ICommand => {
    return defineCommand('udpateChecklistItemStatusLocalCommand', (deferred: ng.IDeferred<IQuery[]>, item: ChecklistItem, newStatus: ChecklistItemStatus) => {
      ngChecklistItemsDatasource.put(_.merge(item, { status: newStatus }));
      deferred.resolve(QueryMediator.runQueries(ngChecklistItemsDatasource));
    });
  });



// WEBPACK FOOTER //
// ./app/lib/checklist/commands/update_checklist_item_status_local_command.ts